import { ReactNode } from "react";
import styles from "./ButtonsContainer.module.css";

interface ButtonsContainerProps {
  children?: ReactNode; // default goes to RIGHT
  left?: ReactNode; // optional left side
  isSideBarOpen?: boolean;
}

export default function ButtonsContainer({
  children,
  left,
  isSideBarOpen,
}: ButtonsContainerProps) {
  const hasLeft = Boolean(left);

  return (
    <div
      className={`${styles.container} ${isSideBarOpen ? styles.shifted : styles.collapsed} ${hasLeft ? styles.withLeft : styles.rightOnly}`}
    >
      {hasLeft && <div className={styles.left}>{left}</div>}
      <div className={styles.right}>{children}</div>
    </div>
  );
}
